import { notFound } from 'next/navigation';

type AggregationStatusResponseType = {
    pageConfig?: {
        content?: {
            status?: number;
        };
    };
};

export const checkAndThrowIfNotFound = (response: AggregationStatusResponseType) => {
    // ofc aggregation responds with { status 200 message "404 not found" }
    if (response?.pageConfig?.content?.status === 404) {
        notFound();
    }
};
